/**
 * @generated SignedSource<<00fa500ceb497a50f72aa3c93983eeef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TagButton_node$data = {
  readonly __typename: string;
  readonly canUpdateTags?: {
    readonly value: boolean;
  };
  readonly id: string;
  readonly tags?: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly " $fragmentType": "TagButton_node";
};
export type TagButton_node$key = {
  readonly " $data"?: TagButton_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"TagButton_node">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TagButton_node",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Tag",
          "kind": "LinkedField",
          "name": "tags",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorizationResult",
          "kind": "LinkedField",
          "name": "canUpdateTags",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "HasTagsInterface",
      "abstractKey": "__isHasTagsInterface"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "cd2022959249dbf829a87c454cc9fe31";

export default node;
